/**
 * Created by joellee on 2/1/16.
 */
dealershipModule.factory('statesCacheService',['imSessionVarsService',
    function(imSessionVarsService) {

        var service = {};

        // methods to cache and retrieve states (geographic). The cache always stores and retrieves *copies*
        // so it is impossible modify the actual cache contents without going through the access methods.

        // Entire cache depends on current provider code a\\.

       var  _providerCode = null,
            _cache = null;

        service.getCachedStates =  function() {
           return (_providerCode && _providerCode == imSessionVarsService.getCurrentProviderCode() && _cache)
                 ? angular.copy(_cache)
                 : [];
        };

        service.setCachedStates =  function(states) {
           _providerCode = imSessionVarsService.getCurrentProviderCode();
           _cache = (_providerCode) ? angular.copy(states) : null;
        };

        return service;
}]);